import useIsMobile from '@/hooks/useIsMobile';
import TagDesktop from './desktop';
import TagMobile from './mobile';
import useTag from './useTag';

const ProductTag = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useTag();

  if (isMobile) {
    return <TagMobile viewModel={viewModel} />;
  }

  return <TagDesktop viewModel={viewModel} />;
};

export default ProductTag;